<h3>
  Add Events
  <button
    class="btn btn-primary pull-right"
    (click)="addEvent()">
    Add new
  </button>
  <div class="clearfix"></div>
</h3>

<br /><br />

<div *ngIf="events?.length > 0">
  <div class="row text-center">
    <div class="col-md-4">
      <div class="btn-group">
        <div class="btn btn-primary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()">
          Previous
        </div>
        <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate">
          Today
        </div>
        <div class="btn btn-primary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()">
          Next
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
    </div>
    <div class="col-md-4">
      <div class="btn-group">
        <div class="btn btn-primary" (click)="setView(CalendarView.Month)" [class.active]="view === CalendarView.Month">
          {{ lang.month }}
        </div>
        <div class="btn btn-primary" (click)="setView(CalendarView.Week)" [class.active]="view === CalendarView.Week">
          {{ lang.week }}
        </div>
        <div class="btn btn-primary" (click)="setView(CalendarView.Day)" [class.active]="view === CalendarView.Day">
          {{ lang.day }}
        </div>
      </div>
    </div>
  </div>
  <br />



  <div [ngSwitch]="view">
    <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate" [events]="events"
      [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen" (dayClicked)="dayClicked($event.day)"
      (eventClicked)="handleEvent('Clicked', $event.event)">
    </mwl-calendar-month-view>
    <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week" [viewDate]="viewDate" [events]="events"
      [refresh]="refresh" (eventClicked)="handleEvent('Clicked', $event.event)">
    </mwl-calendar-week-view>
    <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate" [events]="events" [refresh]="refresh"
      (eventClicked)="handleEvent('Clicked', $event.event)">
    </mwl-calendar-day-view>
  </div>
  
   <ng-template #modalContent let-link="modalData">
    
    <div class="modal-header">
      <h4 class="modal-title pull-left">Event Info</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">

      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.date }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData?.event?.start | date: 'dd/MM/yyyy' }}    
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.title }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData?.event.title }}    
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.description }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData?.event?.meta?.desc }}    
        </div>
      </div>      

    </div>

    
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="modalRef.hide()">
        {{ lang.close }}
      </button>
    </div>
  </ng-template> 


  <!-- <table class="table table-bordered">

    <thead>
      <tr>
        <th>Date</th>
        <th>Title</th>
        <th>Description</th>
      </tr>
    </thead>
  
    <tbody>
      <tr *ngFor="let event of events; let index = index">
        <td>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="event.start"
            (keyup)="refresh.next()">
        </td>
        <td>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="event.meta.desc"
            (keyup)="refresh.next()">
        </td>
        <td>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="event.meta.desc"
            (keyup)="refresh.next()">
        </td>
        
        <td>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="event.title"
            (keyup)="refresh.next()">
        </td>
        <td>
          <button
            class="btn btn-danger"
            (click)="events.splice(index, 1); refresh.next()">
            Delete
          </button>
        </td>
      </tr>
    </tbody>
  
  </table>  

  <div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{ lang?.dataImport }}</h4>
          <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close" (Clicked)="Clicked()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>


        <div class="modal-body column_export">
          <div class="row">
            <form [formGroup]="createForm" (ngSubmit)="onSubmit()">

              <div class="form-group col-sm-12">

                <div class="col-sm-3">
                  <label>{{ lang?.date }}</label>
                </div>
                <div class="col-sm-8">
                  <input type="text" class="form-control" formControlName="date_event">
                </div>
              </div>

              <div class="form-group col-sm-12">

                <div class="col-sm-3">
                  <label>{{ lang?.title }}</label>
                </div>
                <div class="col-sm-8">
                  <input type="text" class="form-control" formControlName="title_event">
                </div>
              </div>

              <div class="form-group col-sm-12">

                <div class="col-sm-3">
                  <label>{{ lang?.description }}</label>
                </div>
                <div class="col-sm-8">
                  <input type="text" class="form-control" formControlName="des_event">
                </div>
              </div>
              <button type="button" class="btn btn-primary" (onClick)="submit">{{ lang?.submit }}</button>
            </form>

          </div>

        </div>


      </div>
    </div>
  </div>  -->




</div>